import React from 'react';
import { Grid, Card, Typography, Table, TableBody, TableRow, TableCell, Chip, Box } from '@mui/material';
import { PageMeta } from '../../lib/instantPageService';

interface MetaInformationProps {
  meta: PageMeta;
}

const MetaInformation: React.FC<MetaInformationProps> = ({ meta }) => {
  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={6}>
        <Card variant="outlined" sx={{ p: 2, height: '100%' }}>
          <Typography variant="h6" gutterBottom>
            Informations de base
          </Typography>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>Titre</TableCell>
                <TableCell>{meta.title}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Description</TableCell>
                <TableCell>{meta.description}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Longueur titre</TableCell>
                <TableCell>
                  <Chip 
                    label={`${meta.title_length} caractères`}
                    color={meta.title_length > 60 ? 'error' : meta.title_length < 30 ? 'warning' : 'success'}
                    size="small"
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Longueur description</TableCell>
                <TableCell>
                  <Chip 
                    label={`${meta.description_length} caractères`}
                    color={meta.description_length > 160 ? 'error' : meta.description_length < 120 ? 'warning' : 'success'}
                    size="small"
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Card>
      </Grid>
      
      <Grid item xs={12} md={6}>
        <Card variant="outlined" sx={{ p: 2, height: '100%' }}>
          <Typography variant="h6" gutterBottom>
            Structure du contenu
          </Typography>
          <Table>
            <TableBody>
              {meta.htags && Object.entries(meta.htags).map(([tag, values]) => (
                <TableRow key={tag}>
                  <TableCell>{tag.toUpperCase()}</TableCell>
                  <TableCell>{Array.isArray(values) ? values.length : 0}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Card>
      </Grid>
      
      <Grid item xs={12}>
        <Card variant="outlined" sx={{ p: 2 }}>
          <Typography variant="h6" gutterBottom>
            Métriques de contenu
          </Typography>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={3}>
              <Box textAlign="center">
                <Typography variant="h4" color="primary">
                  {meta.content?.plain_text_word_count || 0}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Mots
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box textAlign="center">
                <Typography variant="h4" color="primary">
                  {Math.round((meta.content?.plain_text_rate || 0) * 100)}%
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Taux de texte
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box textAlign="center">
                <Typography variant="h4" color="primary">
                  {Math.round(meta.content?.flesch_kincaid_readability_index || 0)}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Flesch-Kincaid
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Box textAlign="center">
                <Typography variant="h4" color="primary">
                  {Math.round((meta.content?.title_to_content_consistency || 0) * 100)}%
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Cohérence titre
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Card>
      </Grid>
    </Grid>
  );
};

export default MetaInformation;
